import { ProjectDto } from '../contracts/project-dto';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getPwermValuationValueDriver = (project: ProjectDto) => {
  const activeMetric = project.pwermInput.valueDriverActiveMetric;
  const metricDefinition = project.pwermInput.metricDefinitions[activeMetric];
  const metricValue = project.pwermInput.valuationDateMetrics[activeMetric];
  return { narrative: metricDefinition.narrative, value: metricValue };
};
